import { ICoreContext } from '@msdyn365-commerce/core-internal';
import { getQuickViewAsync } from '../../../actions/QuickViewServiceAction.g';
import { ICBuyboxConfig } from '../../../modules/c-buybox/c-buybox.props.autogenerated';

export const messageClickHandle = (productId: number, context: ICoreContext, buyboxConfig: ICBuyboxConfig) => {
    const _getQuickViewAsync = async () => {
        try {
            return await getQuickViewAsync({ callerContext: context.actionContext }, productId)
                .catch(err => {
                    console.log(err);
                })
                .then(Value => {
                    return Value;
                });
        } catch (error) {
            console.log(error);
        }
    };
    _getQuickViewAsync().then((response: any) => {
        if (response && response[0] !== undefined) {
            if (typeof window !== 'undefined') {
                const getElement = document.querySelectorAll('.ms-buybox__backorder-message');
                getElement[0].innerHTML = buyboxConfig.labelLanguageDe ? response[0]?.MessageTranslation : response[0]?.Message;
            }
        } else {
            response[0].Message = '';
            console.log(response[0]);
        }
    });
};
